import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Login.css"; // Import the CSS file for styling
import ForgotPasswordModal from "./ForgotPasswordModal";
import SignupModal from "./SignupModal"; // Import the SignupModal component
import MessageModal from "./MessageModal"; // Import the MessageModal component

export default function Login({ closeModal }) {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false); // State for showing/hiding SignupModal
  const [showMessageModal, setShowMessageModal] = useState(false); // State for showing/hiding MessageModal
  const [message, setMessage] = useState(""); // State for the message to be shown in the MessageModal
  const [passwordVisible, setPasswordVisible] = useState(false); // State for toggling password visibility
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false); // State for detecting keyboard visibility

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://trcnswap.net/api/register/Signup",
        credentials
      );
      const data = response.data;
      if (
        data.message === "No such user found" ||
        data.message === "Incorrect password"
      ) {
        setMessage(data.message);
        setShowMessageModal(true);
      } else {
        localStorage.setItem("authToken", data.authToken);
        localStorage.setItem("userId", data.userdata.userId);
        localStorage.setItem("_id", data.userdata._id);
        localStorage.setItem("walletAddress", data.userdata.walletAddress);
        setMessage("Successfully logged in!");
        setShowMessageModal(true);
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setMessage("Error logging in. Please try again.");
      setShowMessageModal(true);
    }
  };

  const handleCloseMessageModal = () => {
    setShowMessageModal(false);
    closeModal();
  };

  useEffect(() => {
    const handleKeyboardShow = () => setIsKeyboardOpen(true);
    const handleKeyboardHide = () => setIsKeyboardOpen(false);

    window.addEventListener("resize", () => {
      if (
        window.innerHeight <
        document.documentElement.clientHeight - 100 // Detect significant height change
      ) {
        handleKeyboardShow();
      } else {
        handleKeyboardHide();
      }
    });

    return () => {
      window.removeEventListener("resize", handleKeyboardShow);
      window.removeEventListener("resize", handleKeyboardHide);
    };
  }, []);

  return (
    <div
      className="modal"
      style={{
        top: isKeyboardOpen ? "10px" : "50%", // Move modal to the top when the keyboard is open
        transform: isKeyboardOpen ? "translateY(0)" : "translateY(-50%)", // Adjust position dynamically
        transition: "top 0.3s ease", // Smooth transition
      }}
    >
      <div className="modal-content">
        <span className="close" onClick={closeModal}>
          &times;
        </span>
        <h2
          style={{
            fontWeight: "600",
            fontSize: "20px",
            borderBottom: "1px solid #7b7d7e",
            display: "inline-block",
            textAlign: "center",
          }}
        >
          Login
        </h2>
        <form id="loginForm" onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="form-group" style={{ position: "relative" }}>
            <label htmlFor="password">Password</label>
            <input
              type={passwordVisible ? "text" : "password"}
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
              style={{
                paddingRight: "40px",
                height: "40px",
                lineHeight: "40px",
              }}
            />
            <i
              className={`fa ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
              style={{
                position: "absolute",
                right: "10px",
                marginTop: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                fontSize: "18px",
                color: "#9ca3af",
              }}
              onClick={() => setPasswordVisible(!passwordVisible)}
            ></i>
          </div>

          <button
            type="submit"
            className="submit-button"
            style={{ backgroundColor: "#6AA1F4" }}
          >
            Login
          </button>
        </form>
        <div className="signup-link">Don't have an account? </div>
        <button
          style={{
            marginTop: "10px",
            backgroundColor: "green",
            color: "white",
            width: "300px",
            height: "50px",
          }}
          onClick={() => setShowSignupModal(true)}
        >
          Create Account
        </button>
        <div className="forgot-password-link" style={{ marginTop: "10px" }}>
          <span
            onClick={() => setShowForgotPassword(true)}
            style={{ color: "red", marginTop: "10px" }}
          >
            Forgot Password?
          </span>
        </div>
      </div>

      {showForgotPassword && (
        <ForgotPasswordModal closeModal={() => setShowForgotPassword(false)} />
      )}
      {showSignupModal && (
        <SignupModal closemod={() => setShowSignupModal(false)} />
      )}
      {showMessageModal && (
        <MessageModal message={message} onClose={handleCloseMessageModal} />
      )}
    </div>
  );
}
